export class Cep {
  private id:            number;
  private bairro:        string;
  private cep:           string;
  private cidade:        number;
  private uf:            string;
  private cod_ibge:      number;
  private tp_logradouro: string;
  private logradouro:    string;

  public toJSON() {
    return {
      id:             this.id,
      bairro:         this.bairro,
      cep:            this.cep,
      cidade:         this.cidade,
      uf:             this.uf,
      cod_ibge:       this.cod_ibge,
      tp_logradouro:  this.tp_logradouro,
      logradouro:     this.logradouro
    };
  }

  public toClass(cep) {
    this.id             = cep.id;
    this.bairro         = cep.bairro;
    this.cep            = cep.cep;
    this.cidade         = cep.cidade;
    this.uf             = cep.uf;
    this.cod_ibge       = cep.cod_ibge;
    this.tp_logradouro  = cep.tp_logradouro;
    this.logradouro     = cep.logradouro;
  }

}
